import { Item } from '../CollabItem/Item'
import { useDecisionModeStore } from './useDecisionMode'
import { Comment } from 'types'
import { IconButton } from '../IconButton/IconButton'
import { ReactComponent as GavelIcon } from 'assets/icons/gavel16.svg'
import { observer } from 'mobx-react-lite'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'

interface Props {
  comment: Comment
}

export const MarkDecisionControl = observer(({ comment }: Props) => {
  const decisionStore = useDecisionModeStore()
  const isSelected = decisionStore?.isCommentMarkedAsDecision(comment)

  return (
    <Item.Control>
      <IconButton
        className={ItemStyles.controlItem}
        variant={isSelected ? 'toggleOn' : 'toggleOff'}
        onPress={() => decisionStore?.toggleCommentAsDecision(comment)}
        icon={GavelIcon}
      />
    </Item.Control>
  )
})
